export default __webpack_public_path__ + "static/media/tarra-picturemark-d.6db6ad93.svg";